export default __webpack_public_path__ + "static/media/CameraButton.32c5921d.png";